import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import {
  getReadyGarmentToSendToWarehouse,
  getStoreWarehouseInfo,
  getStoreWarehouseQrCodeByStatus,
  postSendToWareHouse,
  toGenerateChallan,
} from "../../services/warehouse/StoreWarehouse";
import { InputText } from "primereact/inputtext";
import SuccessModal from "../SuccessModal";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { ProgressSpinner } from "primereact/progressspinner";

import addItemSound from '../../assets/sounds/warehousesound3.mp3';

const ReadyToSendToWareHouse = () => {
  const navigate = useNavigate();

  const { storeData } = getUserData();

  const storeId = storeData.id;

  const audioRef = useRef(new Audio(addItemSound));
  const handleAddItem = () => {
    const audio = audioRef.current;
    audio.currentTime = 0; // Restart from beginning
    audio.play();
  };

  const [modalVisible, setModalVisible] = useState(false);
  const [qrCodes, setQrCodes] = useState(null);
  const [selectedQrCodes, setSelectedQrCodes] = useState([]);
  const [selectedQrCodesRemove, setSelectedQrCodesRemove] = useState([]);
  const [selectedQrCodesChecked, setSelectedQrCodesChecked] = useState([]);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [warehouseList, setWarehouseList] = useState([]);
  const [warehouseValue, setWarehouseValue] = useState("");
  const [isSendButtonPressed, setIsSendButtonPressed] = useState(false);
  const [isSaveButtonPressed, setIsSaveButtonPressed] = useState(false);
  const [loading, setLoading] = useState(true);

  const [searchTerm, setSearchTerm] = useState("");

  const [dataProvider, setDataProvider] = useState([]);
  
  let qrCodeMap = new Map();
  const fetchData = data => {
    getStoreWarehouseQrCodeByStatus(storeId, data)
      .then(response => {
        if (!response.data.error) {
          response.data.forEach(element => {
            qrCodeMap.set(element.qrcode, element.garment);
          });
          setLoading(false);
          setQrCodes(qrCodeMap);
           const suggestions = [];
           qrCodeMap.forEach((garment, qrCode) => {
             if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
               suggestions.push({qrCode, garment});
             }
           });


           const newQrCodes = suggestions.filter(
             item => !selectedQrCodesChecked.includes(item.qrCode),
           );


           const updatedSelectedQrCodes = [
             ...selectedQrCodes,
             ...newQrCodes.map(item => ({
               garment: item.garment,
               qrcode: item.qrCode,
             })),
           ];

           setSelectedQrCodes(updatedSelectedQrCodes);
           setDataProvider(updatedSelectedQrCodes);


          
        }
      })
      .catch(err => {
        console.error('Error:', err);
      });
      getStoreWarehouseInfo(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          const warehouseData = response.data.map((item) => ({
            code: item.id,
            name: item.wareHouse.name,
          }));
          setWarehouseList(warehouseData);
          if (warehouseData.length == 1)
            setWarehouseValue(warehouseData[0]);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    const data = {
      status: ['READY_TO_SEND_WARE_HOUSE'],
    };
    fetchData(data);
  }, []);


  const handleSelectAllSearchedData = () => {
    const suggestions = [];
    qrCodes.forEach((garment, qrCode) => {
      if (qrCode.toLowerCase().startsWith(searchTerm.toLowerCase())) {
        suggestions.push({qrCode, garment});
      }
    });


    const newQrCodes = suggestions.filter(
      item => !selectedQrCodesChecked.includes(item.qrCode),
    );


    const updatedSelectedQrCodes = [
      ...newQrCodes.map(item => ({
        garment: item.garment,
        qrcode: item.qrCode,
      })),
    ];


    setSelectedQrCodesRemove(updatedSelectedQrCodes);
    // setDataProvider(dataProvider.cloneWithRows(updatedSelectedQrCodes));


    const updatedCheckedQrCodes = [
      ...selectedQrCodesChecked,
      ...newQrCodes.map(item => item.qrCode),
    ];
    setSelectedQrCodesChecked(updatedCheckedQrCodes);
  };



  const handleScan = ({data}) => {    
    if (data) {
      // Ensure data exists
      if (qrCodes.has(data) && !selectedQrCodesChecked.includes(data)) {
        let scannedData = {
          garment: qrCodes.get(data),
          qrcode: data,
        };
        setSelectedQrCodesRemove([...selectedQrCodesRemove, scannedData]);
        // setDataProvider(
        //   dataProvider.cloneWithRows([...selectedQrCodes, scannedData]),
        // );
        handleAddItem()
        setSelectedQrCodesChecked([...selectedQrCodesChecked, data]);
      } else {
        console.error(`Data ${data} already exists in the scannedQrArray.`);
      }
    } else {
      console.error('Scanned QR data is null or undefined');
    }
  };

  
  const handleWarehouseChange = (selectedItem) => {
    setWarehouseValue(selectedItem);
  };


  const data = {
    qrcodeList: selectedQrCodesRemove.map(qr => qr.qrcode),
    status: 'IN_PROCESS',
  };


  const handleRemoveAllSelectedData = () => {
        // Check if the button has already been pressed
          if (!isSaveButtonPressed) {
            // Set the state to indicate that the button has been pressed
            setIsSaveButtonPressed(true);
            const data = {
              qrcodeList: selectedQrCodesRemove.map(qr => qr.qrcode),
              status: 'IN_PROCESS',
            };


            getReadyGarmentToSendToWarehouse(storeId, data)
              .then(response => {
                if (!response.data.error) {
                  const Res = response.data;
                  const message = Res.message;
                  const success = Res.status;
                  if (success === true) {
                    setModalVisible(true);
                    setModalStatus('success');
                    setModalText(message);
                    setTimeout(() => {
                      setIsSaveButtonPressed(false);
                      navigate('/StoreWarehouse');
                    }, 1500);
                  } else {
                    setModalVisible(true);
                    setModalStatus('not Success');
                    setModalText(message);
                    setTimeout(() => {
                      setIsSaveButtonPressed(false);
                      navigate('/StoreWarehouse');
                    }, 1500);
                  }
                }
              })
              .catch(err => {
                console.error('Error:', err);
                setIsSaveButtonPressed(false);
              });
          }
  };
 
  const handleSendToWarehouse = () => {
    // Check if the button has already been pressed
    if (!isSendButtonPressed) {
      // Set the state to indicate that the button has been pressed
      setIsSendButtonPressed(true);
      const data = {
        qrcodeList: selectedQrCodes.map((qr) => qr.qrcode),
        status: "READY_TO_SEND_WARE_HOUSE",
      };

      getReadyGarmentToSendToWarehouse(storeId, data)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            const success = Res.status;
            if (success === true) {
              toGenerateChallan(warehouseValue.code)
                .then((response) => {
                  if (!response.data.error) {
                    const Res = response.data;
                    const data = {
                      qrCodeInfoList: selectedQrCodes.map((item) => ({
                        qrCode: item.qrcode,
                      })),
                      wareHouseStoreChallanDTO: response.data,
                    };

                    setIsSendButtonPressed(false);
                    postSendToWareHouse(storeId, data)
                      .then((response) => {
                        if (!response.data.error) {
                          const Res = response.data;
                          const message = Res.message;
                          const success = Res.status;
                          if (success === true) {
                            setModalVisible(true);
                            setModalStatus("success");
                            setModalText(message);
                            setTimeout(() => {
                              navigate("/ChallanList");
                            }, 1500);
                          } else {
                            setModalVisible(true);
                            setModalStatus("not Success");
                            setModalText(message);
                          }
                        }
                      })
                      .catch((err) => {
                        console.error("Error:", err);
                      });
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            } else {
              setModalVisible(true);
              setModalStatus("not Success");
              setModalText("");
              const data = {
                status: ["IN_PROCESS"],
              };
              fetchData(data);
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  };

  const rowRenderer = () => {
    
    return dataProvider?.map((item, index) => {
      const isSelected = selectedQrCodesChecked.includes(item.qrcode);
      return (
        <div
          key={index}
          onClick={() => handleScan({ data: item.qrcode })}
          className="flex flex-row py-1 mx-2 justify-content-between cursor-pointer"
        >
          <p className="flex-1 text-lg font-normal ">{item.qrcode}</p>
          <p className="flex-1 text-lg font-normal ">
            {(item.garment.replace(/_/g, " ") + "").substring(0, 20)}
            {(item.garment + "").length > 20 ? "..." : ""}
          </p>

          <div className="flex-1 text-lg font-normal text-right">
            <div>
              {isSelected ? (
                <img
                  src={
                    "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                  }
                  style={{ width: "5%" }}
                />
              ) : (
                <img
                  src={"Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"}
                  style={{ width: "5%" }}
                />
              )}
            </div>
          </div>
        </div>
      );
    });
  };

 
  const handleBackButton = () => {
    navigate("/StoreWarehouse");
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl text-white font-bold capitalize">
                Ready To Send
              </p>
            </div>
            <div className="ml-3 flex justify-content-center align-items-center mr-4">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center cursor-pointer" 
              onClick={() => handleSelectAllSearchedData()}>
              <img
                src={"images/plus.png"}
                style={{ width: "30px" }}
              />
              </div>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div className="flex-1 flex flex-column justify-content-center align-items-center">
          <ProgressSpinner />

          <p
            style={{
              color: "#000",
              fontSize: 20,
              fontWeight: "700",
              alignSelf: "center",
            }}
          >
            Garment List is Loading...
          </p>
        </div>
      ) : (
        <div className="flex flex-1 ">
          <div
            className=" flex-1"
          >
            <div>
              <div className="flex-1">
                <div className="flex-1">
                  <div className="mt-3 mb-1 mx-4 flex flex-row justify-content-between">
                    <p className="w-full text-3xl  font-bold text-start">
                      Garments Tag List
                    </p>

                    {selectedQrCodes.length > 0 && (
                      <div
                        className="flex justify-content-end align-items-center cursor-pointer"
                        onClick={handleRemoveAllSelectedData}
                      >
                        <img
                          src={"images/Cross.jpeg"}
                          style={{ width: "8%" }}
                        />
                      </div>
                    )}
                  </div>
                </div>
                  <div>
                    <div className="flex flex-row py-1 mx-2 justify-content-between">
                      <p className="flex-1 text-2xl font-medium ">Tag</p>
                      <p className="flex-1 text-2xl font-medium">Garment</p>

                      <p className="flex-1 text-2xl font-medium text-right">
                        Action
                      </p>
                    </div>
                    <div>
                      {selectedQrCodes.length > 0 ? (
                      <div style={{ overflowY: "auto", height: "55vh" }}>
                        {rowRenderer()}
                      </div>
                      )
                      : 
                      <div className="flex-1 flex flex-column justify-content-center align-items-center">
                        <p
                          style={{
                            color: "#000",
                            fontSize: 20,
                            fontWeight: "700",
                            alignSelf: "center",
                          }}
                        >
                          No Data Found
                        </p>
                      </div>
                      }
                    </div>
                  </div>
                  
              </div>
              <SuccessModal
                setModalVisible={setModalVisible}
                modalVisible={modalVisible}
                status={modalStatus}
                text={modalText}
              />
            </div>
            {selectedQrCodes.length > 0 && (
              <div className="my-1 mx-2">
                <div className="mx-2 mt-2">
                  <Dropdown
                    // value={
                    //   warehouseValue ? warehouseValue : warehouseList[0].name
                    // }
                    value={warehouseValue}
                    onChange={(e) => handleWarehouseChange(e.value)}
                    options={warehouseList}
                    placeholder="Select Warehouse"
                    disabled={isSendButtonPressed}
                    optionLabel="name"
                    className="w-full  bg-white-alpha-20 border-round-xl text-2xl text-primary-50"
                  />
                </div>

                <div className="flex-1 mx-2 mb-1 mt-3 sticky z-2 bottom-0">
                  <div className=" flex justify-content-center">
                    <Button
                      onClick={handleSendToWarehouse}
                      disabled={
                        (warehouseValue === undefined || warehouseValue === "") ? true : isSendButtonPressed
                      }
                      className="flex justify-content-center text-2xl w-full border-round-xl border-none cursor-pointer"
                    >
                      <p className="text-xl font-bold text-white text-center">
                        {isSendButtonPressed
                          ? "Generating..."
                          : "Generate Challan"}
                      </p>

                      <div className="flex justify-content-center ml-5 relative">
                      <i
              className="pi pi-shopping-cart"
              style={{ fontSize: "27px", color: "#fff" }}
            ></i>
                        <div
                          style={{
                            left: 28,
                            position: "absolute",
                            top: -10,
                            backgroundColor: "red",
                            borderRadius: 20,
                            minWidth: 36,
                            height: 36,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <p className=" text-md  font-normal text-center">
                            {selectedQrCodes.length}
                          </p>
                        </div>
                      </div>
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ReadyToSendToWareHouse;
